// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__XXj-R","footerContent":"footer_footerContent__duq4o","footerSection":"footer_footerSection__lzyFr","socialIcon":"footer_socialIcon__jHoKK"};